// v2 debug buffer — records recent /api/v2/* calls and trackV2 events, surfaced by
// the on-device V2Debug overlay when debug mode is on (?debug=1). Purpose-built for
// the v2 evidence/workspace flow (the old DebugOverlay was v1-ATS-pipeline only).
//
// Zero overhead when disabled: every record* fn early-returns unless enabled. No
// PII — request/response BODIES are never stored, only method, path, status,
// duration, and (on failure) the API's own detail message. Analytics props arrive
// already sanitized (v2Analytics.sanitizeProps).
const MAX = 50;
let enabled = false;
const api = [];
const events = [];
const listeners = new Set();

export function setV2DebugEnabled(v) { enabled = !!v; }
export function isV2DebugOn() { return enabled; }

function notify() { for (const l of listeners) { try { l(); } catch { /* no-op */ } } }
function push(arr, item) { arr.unshift(item); if (arr.length > MAX) arr.length = MAX; notify(); }

// { method, path, status, ms, ok, error?, note? }
export function recordApi(entry) { if (!enabled) return; push(api, { t: Date.now(), ...entry }); }
export function recordEvent(name, props) { if (!enabled) return; push(events, { t: Date.now(), name, props }); }

export function getApi() { return api; }
export function getEvents() { return events; }
export function clearV2Debug() { api.length = 0; events.length = 0; notify(); }
export function subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn); }

// Live device/layout snapshot — the numbers we keep chasing on mobile Chrome.
export function deviceSnapshot() {
  if (typeof window === "undefined") return {};
  const de = document.documentElement;
  return {
    vw: window.innerWidth,
    vh: window.innerHeight,
    dpr: Math.round((window.devicePixelRatio || 1) * 100) / 100,
    overflowX: de.scrollWidth - de.clientWidth, // >0 means a horizontal-scroll bug
    online: navigator.onLine,
  };
}
